import { type AddHookResponse, mutationAdd } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useImportCache } from './cache'
import { type ImportAddInput, type ImportAddSuccess, toResponseError } from '@terros/common'

export function useAddImport(): AddHookResponse<ImportAddInput, ImportAddSuccess> {
  const mutation = useTantalimMutation<ImportAddInput, ImportAddSuccess>({
    url: '/import/add',
  })
  const cache = useImportCache()

  async function add(input: ImportAddInput): Promise<ImportAddSuccess> {
    try {
      const data = await mutation.mutateAsync(input)
      cache.addItem(data.importData)

      return data
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
